import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../../../../providers';
import { PaymentControllerImpl, PaymentSubscriptionResponse } from '../../../business';
import { PaymentPageFactoryImpl } from '../../api';

export function PaymentPage({ navigate }) {
    const { userData, setCallbackLogin, handleLogout } = useAuth();
    const location = useLocation();
    const [isLoading, setLoading] = useState<boolean>(true);
    const [paymentData, setPaymentData] = useState<PaymentSubscriptionResponse | null>(null);
    const chosenPlan = location.state?.id;

    const factory = new PaymentPageFactoryImpl();
    const controller = new PaymentControllerImpl();

    useEffect(() => {
        const { username } = userData;
        if (username === "") {
            setCallbackLogin(
                {
                    goBack: true,
                    origin: '/payment',
                    params: {
                        id: chosenPlan,
                        frequency: location.state?.frequency
                    }
                }
            );
            navigate('/auth');
            return;
        }
        if (!chosenPlan) {
            navigate('/subscription');
            return;
        }
    }, [userData]);

    const fetchData = async () => {
        try {
            const response = await controller.onLoad(chosenPlan, location.state?.frequency);
            setLoading(false);
            setPaymentData(response);
        } catch (error) {
            if (error === "401") {
                setCallbackLogin(
                    {
                        goBack: true,
                        origin: '/payment',
                        params: {
                            id: chosenPlan,
                            frequency: location.state?.frequency
                        }
                    }
                );
                handleLogout();
                navigate('/auth');
            } else {
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        fetchData();
    }, [chosenPlan]);
    return (
        <>
            {isLoading ? <Spinner /> : factory.create(paymentData, location.state)}
        </>
    );
}